import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Overline, Reveal } from "../site/Motion";

export const ServiceFaq = ({ faqs }) => (
  <section className="border-t border-white/10 bg-[var(--ink)] py-24 md:py-32" data-testid="service-faq">
    <div className="mx-auto grid max-w-[1440px] gap-10 px-5 md:px-10 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <Overline>Questions</Overline>
        <h2 className="mt-6 font-display text-5xl font-black uppercase leading-[0.9] md:text-6xl">Asked often.</h2>
      </div>
      <Reveal className="lg:col-span-7 lg:col-start-6">
        <Accordion type="single" collapsible defaultValue="faq-0">
          {faqs.map(([q, a], i) => (
            <AccordionItem key={q} value={`faq-${i}`} className="border-white/15">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-2xl font-extrabold uppercase hover:no-underline hover:text-[var(--signal)] md:text-3xl">
                {q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base text-[var(--bone-2)]">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
